import StylesService from '@/services/codebooks/StylesService'

export default {
  namespaced: true,
  state: {
    stylesList: []
  },
  getters: {
    stylesList: state => state.stylesList
  },
  actions: {
    refreshStyles ({ commit }) {
      return StylesService.getAllStyles()
        .then(list => {
          commit('SET_STYLES', list)
        })
    },
    addNewStyle ({ commit }, style) {
      return StylesService.saveStyle(style).then(result => {
        style.id = result.data
        commit('ADD_STYLE', style)
        return style
      })
    },
    editStyle ({ commit }, style) {
      return StylesService.saveStyle(style).then(result => {
        commit('EDIT_STYLE', style)
        return style
      })
    },
    deleteStyle ({ commit }, style) {
      return StylesService.removeStyle(style).then(result => {
        commit('DELETE_STYLE', style)
      })
    }
  },
  mutations: {
    SET_STYLES (state, list) {
      state.stylesList = list
    },
    EDIT_STYLE (state, style) {
      const current = state.stylesList[style.index]
      current.name = style.name
    },
    ADD_STYLE (state, style) {
      const newStyle = {
        id: style.id,
        name: style.name
      }
      state.stylesList.push(newStyle)
    },
    DELETE_STYLE (state, style) {
      state.stylesList.splice(style.index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/codebook/styles.js